import React from "react";

import ErrorImage from "@common/assets/images/FTUX/not-found-graphic.png";
import PageStateView from "@common/components/PageStateView/components/PageStateView";

interface Props {
  title: string;
  subtitle: string;
  button?: {
    url: string;
    title: string;
  };
}

export function ErrorStateView({ title, subtitle, button }: Props) {
  return (
    <PageStateView
      title={title}
      subtitle={subtitle}
      info={
        <>
          {"If you think it's a system bug, "}
          <a href="javascript:window.Intercom?.('showNewMessage')">{"please drop us a message"}</a>.
        </>
      }
      imageSrc={ErrorImage}
      button={button}
    />
  );
}
